import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGlobalStore } from '../../../store/global-store'
import { Toast } from './components/toast'
import { useUpdateReturnValueLuck } from './use-update-return-value-luck'

export const ReturnValueLuck = memo(() => {
  useUpdateReturnValueLuck()

  const notifyGiftLuckList = useGlobalStore(
    useShallow((state) => {
      return state.notifyGiftLuckList
    }),
  )

  return (
    <div className="w-screen h-screen flex justify-center flex-row relative">
      <div className="mt-24 absolute left-0" style={{ marginTop: 200 }}>
        {notifyGiftLuckList?.left && (
          <Toast
            key={notifyGiftLuckList?.left?.id}
            toast={notifyGiftLuckList.left}
            position="left"
          />
        )}
      </div>

      <div className="mt-12" style={{ marginTop: 90 }}>
        {notifyGiftLuckList?.top && (
          <Toast
            key={notifyGiftLuckList?.top?.id}
            toast={notifyGiftLuckList.top}
            position="top"
          />
        )}
      </div>

      <div className="mt-24 absolute right-0" style={{ marginTop: 200 }}>
        {notifyGiftLuckList?.right && (
          <Toast
            key={notifyGiftLuckList?.right?.id}
            toast={notifyGiftLuckList.right}
            position="right"
          />
        )}
      </div>
    </div>
  )
})
